module.exports = {
    myAccount: {
        securityTabToolTipText: 'Try it!',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/my-account.js